import { c as _c } from "react/compiler-runtime";
import { Modal, ModalSizeEnum, PrimaryButton } from '@systemeio/ui';
import RuleSave from 'modules/automation-rules/components/rule-save';
import { useRuleState } from 'modules/automation-rules/hooks/use-rule-state';
import { SpecificTriggerRulesProps } from 'modules/automation-rules/specific-trigger-rules';
import React, { useRef, useState } from 'react';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { SpecificTriggerRule } from './specific-trigger-rule';
export interface SpecificTriggerRuleCreateProps extends SpecificTriggerRulesProps {}
const SpecificTriggerRuleCreate = t0 => {
  const $ = _c(36);
  const {
    availableTriggersData,
    getRelatedAndUnrelatedTriggersData,
    specificTriggerRulesData,
    customAddTriggerHandler,
    noRelatedMessage
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const [opened, setOpened] = useState(false);
  const {
    tempState,
    setTempState,
    errors,
    setErrors,
    clearState
  } = useRuleState();
  const maxTriggerId = useRef(0);
  const maxActionId = useRef(0);
  const [isFetching, setIsFetching] = useState(false);
  let t1;
  if ($[0] !== availableTriggersData || $[1] !== specificTriggerRulesData) {
    t1 = async () => {
      await specificTriggerRulesData.mutate();
      await availableTriggersData.mutate();
      setOpened(false);
    };
    $[0] = availableTriggersData;
    $[1] = specificTriggerRulesData;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const afterSave = t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => setOpened(true);
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = !availableTriggersData.data || availableTriggersData.data.length === 0;
  let t4;
  if ($[4] !== t) {
    t4 = t("dashboard.funnel.automation_rules.add_rule");
    $[4] = t;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t3 || $[7] !== t4) {
    t5 = <PrimaryButton onClick={t2} disabled={t3}>{t4}</PrimaryButton>;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t) {
    t6 = t("dashboard.automation_rule.edit.create_title");
    $[9] = t;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = () => setOpened(false);
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== availableTriggersData.data || $[13] !== customAddTriggerHandler || $[14] !== errors || $[15] !== getRelatedAndUnrelatedTriggersData || $[16] !== isFetching || $[17] !== noRelatedMessage || $[18] !== setTempState || $[19] !== tempState) {
    t8 = <SpecificTriggerRule noRelatedMessage={noRelatedMessage} isFetching={isFetching} tempState={tempState} setTempState={setTempState} errors={errors} maxActionId={maxActionId} maxTriggerId={maxTriggerId} availableTriggers={availableTriggersData.data} getRelatedAndUnrelatedTriggersData={getRelatedAndUnrelatedTriggersData} customAddTriggerHandler={customAddTriggerHandler} />;
    $[12] = availableTriggersData.data;
    $[13] = customAddTriggerHandler;
    $[14] = errors;
    $[15] = getRelatedAndUnrelatedTriggersData;
    $[16] = isFetching;
    $[17] = noRelatedMessage;
    $[18] = setTempState;
    $[19] = tempState;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== afterSave || $[22] !== isFetching || $[23] !== setErrors || $[24] !== tempState) {
    t9 = <div className="mt-5 flex justify-center"><RuleSave setErrors={setErrors} afterSave={afterSave} isFetching={isFetching} setIsFetching={setIsFetching} rule={tempState} /></div>;
    $[21] = afterSave;
    $[22] = isFetching;
    $[23] = setErrors;
    $[24] = tempState;
    $[25] = t9;
  } else {
    t9 = $[25];
  }
  let t10;
  if ($[26] !== clearState || $[27] !== isFetching || $[28] !== opened || $[29] !== t6 || $[30] !== t8 || $[31] !== t9) {
    t10 = <Modal afterLeave={clearState} size={ModalSizeEnum.big} isFetching={isFetching} title={t6} opened={opened} onClose={t7}>{t8}{t9}</Modal>;
    $[26] = clearState;
    $[27] = isFetching;
    $[28] = opened;
    $[29] = t6;
    $[30] = t8;
    $[31] = t9;
    $[32] = t10;
  } else {
    t10 = $[32];
  }
  let t11;
  if ($[33] !== t10 || $[34] !== t5) {
    t11 = <div className="flex justify-center px-6 py-4 lg:px-8">{t5}{t10}</div>;
    $[33] = t10;
    $[34] = t5;
    $[35] = t11;
  } else {
    t11 = $[35];
  }
  return t11;
};
export default SpecificTriggerRuleCreate;